export const TOPPINGS = [
    {
        id: 1,
        topping: "Small Boba",
        price: 0.00
    },
    {
        id: 2,
        topping: "Lychee Jelly",
        price: 1.00
    },
    {
        id: 3,
        topping: "Coffee Jelly",
        price: 1.00
    },
    {
        id: 4,
        topping: "Popping Boba",
        price: 1.00
    },
    {
        id: 5,
        topping: "Almond Jelly",
        price: 1.00
    },
    {
        id: 6,
        topping: "Regular Boba",
        price: 0.00
    }]